import React from "react";

import Cube from "components/measuring/components/cube";
import { transformDimension } from "../../helpers";
import { WeightTransformer } from "./weight-transformer";
import { lbsCode, ozCode } from "./consts";

export const Measurements = ({ dimensions, packageType, uom, showCalculatedWeight }) => {
    const isLbs = uom?.weight === lbsCode;
    const isOz = uom?.weight === ozCode;

    return (
        <div className="flex-column">
            <div className="flex align-center">
                <Cube
                    dimensions={dimensions}
                    scaleMultiplier={29}
                />
                <div>
                    <span>
                        <strong>{transformDimension(dimensions.height)}</strong> {uom.height} (h)
                    </span>
                    <span className="symbol">x</span>
                    <span>
                        <strong>{transformDimension(dimensions.width)}</strong> {uom.width} (w)
                    </span>
                    <span className="symbol">x</span>
                    <span className="bordered">
                        <strong>{transformDimension(dimensions.depth)}</strong> {uom.depth} (d)
                    </span>
                    <span className="bordered">
                        <strong>{transformDimension(dimensions.weight)}</strong> {uom.weight}
                    </span>
                    {packageType && (
                        <span>
                            Package Type: <strong>{packageType}</strong>
                        </span>
                    )}
                </div>
            </div>
            {showCalculatedWeight && (
                <div className="flex align-center justify-content-end">
                    <WeightTransformer
                        isOz={isOz}
                        isLbs={isLbs}
                        weight={dimensions.weight}
                    />
                </div>
            )}
        </div>
    );
};
